"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkModel = void 0;
class NetworkModel {
    toNet() {
        throw Error(`Not Implemented: ${this.constructor.name}.toNet()`);
    }
    fromNet(data) {
        throw Error(`Not Implemented: ${this.constructor.name}.fromNet()`);
    }
}
exports.NetworkModel = NetworkModel;
